// React
import React from "react";

import Moment from 'moment';

import './tweet.css';

const Tweet = ({tweet}) => {


    const clout = ((tweet.favorite_count * 0.3) + (tweet.retweet_count * 0.3) + (tweet.quote_count * 0.2) + (tweet.reply_count * 0.2)) + (tweet.user.followers_count * 0.25);

    return (
        <div className='tweet'>
            <div className='header'>
                <div className="profile">
                    <img className='profile_photo' src={tweet.user.profile_image_url}></img>
                    <div>{tweet.user.name}</div>
                </div>
                <div className='username'>@{tweet.user.screen_name}</div>
            </div>
            <div className='tweetContent'>
                {tweet.text}
            </div>
            <div className='tweetDetails'>

                <div className='details-left'>
                    <div className='tweetFactor'>
                        <i className="icon-rocket"></i>{clout}
                    </div>
                    <div className='tweetFactor'>
                        <i className={tweet.favorited ? "icon-heart5 red-text" : "icon-heart6 red-text"}></i>{tweet.favorite_count}
                    </div>
                    <div className='tweetFactor'>
                        <i className="icon-loop"></i>{tweet.retweet_count + tweet.quote_count}
                    </div>
                </div>
                <div>
                {Moment(tweet.created_at).fromNow()}
                </div>
            </div>
        </div>
    );

};

export default Tweet;


// WEBPACK FOOTER //
// ./src/Views/Peak/Tweet.js